export const vhAdapter = function (): void {
	const updateVh = () => {
		const height = window.visualViewport?.height ?? window.innerHeight;
		const vh = height * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	};

	updateVh();

	if (window.visualViewport) {
		window.visualViewport.addEventListener('resize', updateVh);
	} else {
		window.addEventListener('resize', updateVh);
	}

	window.addEventListener('orientationchange', () => {
		setTimeout(updateVh, 100);
	});
};